import { render, staticRenderFns } from "./CytomineDescription.vue?vue&type=template&id=2038f6b8&scoped=true&"
import script from "./CytomineDescription.vue?vue&type=script&lang=js&"
export * from "./CytomineDescription.vue?vue&type=script&lang=js&"
import style0 from "./CytomineDescription.vue?vue&type=style&index=0&id=2038f6b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2038f6b8",
  null
  
)

export default component.exports